import { Department } from '../../../entities/User'

export const mapC_Suit = (department: Department | undefined) => {
    if (department === Department.C_SUITE) {
        return 'cSuite'
    }
    return department
}
